import { Button, Drawer } from 'antd';
import HistoryPredictions from 'components/HistoryPredictions';
import { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getAllSetting } from '../../service/base';
import { CONST_SITE } from '../../utils/common/const';
import CountDownFinal from './CountDownFinal';

const navItems = [
  { name: 'TRANG CHỦ', href: '#' },
  { name: 'DỰ ĐOÁN', href: '/' },
  { name: 'THỂ LỆ', href: '/rule' },
  { name: 'KẾT QUẢ', href: '/prize-structure' }
];

const Header = () => {
  const location = useLocation();
  const activeNav = location.pathname;
  const [settings, setSettings] = useState({
    link_login: '#',
    link_register: '#',
    link_home: '#'
  });
  const mounted = useRef(false);
  const [isModalHistory, setIsModalHistory] = useState(false);
  const [IP, setIP] = useState('');
  const [FP, setFP] = useState('');
  const [isShowMenu, setIsShowMenu] = useState(false);

  useEffect(() => {
    mounted.current = true;

    const fetchData = async () => {
      try {
        const res = await getAllSetting({
          site: CONST_SITE.SC88
        });
        if (mounted.current) {
          const settingsMap = {};
          res.data.forEach((item) => {
            settingsMap[item.key] = item.content || '#';
          });
          setSettings(settingsMap);
          // Update the home link in navItems
          navItems[0].href = settingsMap.link_home || '/';
        }
      } catch (error) {
        console.error('Error fetching settings:', error);
      }
    };

    fetchData();

    return () => {
      mounted.current = false;
    };
  }, []);

  return (
    <div className="w-full">
      <div
        className="w-full max-w-[1199px] mx-auto mt-2 md:mt-8 rounded-[20px] md:rounded-[100px]
            flex flex-row justify-between items-center 
            bg-[#E8EBEE]
            px-[12px] md:px-[40px] py-[24px]
            h-[80px] md:h-[88px] lg:h-[96px] gap-[8px]"
        style={{
          boxShadow:
            '5px 5px 10px #F27121, -4px -4px 10px #FFFFFF66, inset 5px 5px 5px #FFFFFF, inset -5px -5px 10px #FEB562',
          boxSizing: 'border-box'
        }}
      >
        <div className="flex lg:hidden justify-start items-center">
          <Drawer
            placement="left"
            onClose={() => setIsShowMenu(false)}
            open={isShowMenu}
            closeIcon={null}
            width={260}
            bodyStyle={{ padding: 0, position: 'relative' }}
            style={{
              // Hide scrollbar for the Drawer
              overflow: 'auto',
              scrollbarWidth: 'none', // For Firefox
              msOverflowStyle: 'none' // For IE, Edge
            }}
            // For Ant Design Drawer: pass className to customize scrollbar for inner content
            className="drawer-hide-scrollbar"
          >
            {/* Inline scrollbar-hide CSS for injected content */}
            <style>
              {`
                  .drawer-hide-scrollbar {
                    scrollbar-width: none !important;        /* Firefox */
                    -ms-overflow-style: none !important;     /* IE and Edge */
                  }
                  .drawer-hide-scrollbar::-webkit-scrollbar {
                    display: none !important;                /* Chrome, Safari and Opera */
                    width: 0 !important;
                    background: transparent !important;
                  }
                `}
            </style>
            {/* Logo on Top */}
            <div
              className="flex items-center justify-center w-full py-6 border-b border-gray-200"
              style={{ background: '#FFFFFF' }}
            >
              <Link to="/" onClick={() => setIsModalHistory(false)}>
                <img
                  src="/assets/images/header/logo.png"
                  alt="Logo"
                  className="h-[40px] w-auto object-contain mx-auto"
                />
              </Link>
            </div>
            {/* Close Button X */}
            <button
              onClick={() => setIsShowMenu(false)}
              className="absolute top-3 right-3 z-10 hover:opacity-80 transition-opacity"
              aria-label="Đóng menu"
              style={{
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
                padding: 0
              }}
            >
              <img
                src="/assets/images/header/close.png"
                alt="Close"
                className="w-8 h-8 object-contain"
                style={{
                  filter:
                    'brightness(0) saturate(100%) invert(47%) sepia(95%) saturate(1752%) hue-rotate(349deg) brightness(97%) contrast(93%)'
                }}
              />
            </button>
            {/* Hide scrollbar for this menu list as well */}
            <div
              className="flex flex-col h-full"
              style={{ background: '#FFFFFF', overflow: 'auto' }}
            >
              <Link
                to="/"
                onClick={() => {
                  setIsShowMenu(false);
                  setIsModalHistory(false);
                }}
                className="flex items-center px-5 py-4 hover:bg-[#f27121] hover:text-white font-bold text-xl text-[#f27121] transition-colors"
              >
                DỰ ĐOÁN
              </Link>
              <Link
                to="/rule"
                onClick={() => {
                  setIsShowMenu(false);
                  setIsModalHistory(false);
                }}
                className="flex items-center px-5 py-4 hover:bg-[#f27121] hover:text-white font-bold text-xl text-[#f27121] transition-colors"
              >
                THỂ LỆ
              </Link>
              <Link
                to="/prize-structure"
                onClick={() => {
                  setIsShowMenu(false);
                  setIsModalHistory(false);
                }}
                className="flex items-center px-5 py-4 hover:bg-[#f27121] hover:text-white font-bold text-xl text-[#f27121] transition-colors"
              >
                KẾT QUẢ
              </Link>
              <Button
                type="text"
                className="flex items-center justify-start px-5 py-8 font-bold text-xl w-full text-left text-[#f27121] hover:bg-[#f27121] hover:text-white transition-colors group"
                onClick={() => {
                  setIsShowMenu(false);
                  setIsModalHistory(false);
                  setIsModalHistory(true);
                }}
                style={{ color: '#f27121', background: 'transparent', border: 'none' }}
              >
                <span className="w-full block transition-colors">LỊCH SỬ</span>
              </Button>
              <Link
                to={settings.link_login}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center px-5 py-4 f27121 font-bold text-xl text-[#f27121] transition-colors"
                onClick={() => {
                  setIsShowMenu(false);
                  setIsModalHistory(false);
                }}
              >
                Đăng nhập
              </Link>
              <Link
                to={settings.link_register}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center px-5 py-4 hover:bg-[#f27121] hover:text-white font-bold text-xl text-[#f27121] transition-colors"
                onClick={() => {
                  setIsShowMenu(false);
                  setIsModalHistory(false);
                }}
              >
                Đăng ký
              </Link>
            </div>
          </Drawer>
          <Button type="link" onClick={() => setIsShowMenu(true)} style={{ color: '#f27121' }}>
            <img
              src="/assets/images/header/menu.png"
              alt=""
              className="h-[32px] w-[32px] md:w-auto object-contain mt-1"
              style={{
                filter:
                  'brightness(0) saturate(100%) invert(47%) sepia(95%) saturate(1752%) hue-rotate(349deg) brightness(97%) contrast(93%)'
              }}
            />
          </Button>
        </div>
        <div className="flex justify-center items-center shrink-0">
          <Link key={navItems[0].name} to={navItems[0].href || '/'}>
            <img
              src="/assets/images/header/logo.png"
              alt=""
              className="h-[32px] md:h-[50px] mt-2 md:mt-0 w-auto object-contain"
            />
          </Link>
        </div>
        <div className="flex justify-center items-center flex-1">
          <div className="lg:flex hidden flex-row justify-center items-center w-full gap-3 lg:gap-6">
            {navItems.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`text-center text-[14px] px-4 py-1.5 rounded-lg lg:text-[15px] xl:text-[16px] font-semibold ${
                  activeNav === item.href
                    ? 'text-[#FFF] bg-[#f27121]'
                    : 'text-[#3E4C5C] bg-transparent'
                } ${item.name === 'TRANG CHỦ' ? 'hidden md:block' : ''}`}
              >
                {item.name}
              </Link>
            ))}
            <button
              onClick={() => setIsModalHistory(true)}
              className={`text-center text-[14px] lg:text-[15px] xl:text-[16px] font-semibold text-[#3E4C5C] cursor-pointer bg-transparent border-0`}
            >
              LỊCH SỬ
            </button>
          </div>
        </div>
        <div className="flex justify-end shrink-0">
          <div className="flex flex-row justify-end gap-4 h-full">
            {/* Login Button */}
            <Link
              to={settings.link_login}
              target="_blank"
              rel="noopener noreferrer"
              className="hidden md:flex items-center justify-center px-[25px] py-[4px] pt-[8px] h-[46px] w-[134px] rounded-[109px] font-bold text-[16px] leading-[24px] text-center whitespace-nowrap text-[#f27121]"
              style={{
                background: 'linear-gradient(to bottom, #ffffff, #e9e1e1)',
                border: '2px solid transparent',
                // borderBottom: '2px solid #f27121',
                boxShadow: '0px 4px 6px -1px #f27121'
              }}
            >
              ĐĂNG NHẬP
            </Link>

            {/* Register Button */}
            <div
              className="hidden md:flex bg-[#feb562] flex-col items-start p-px rounded-full w-[134px] h-[46px]"
              style={{
                boxShadow:
                  '0px 12.522px 10.017px 0px rgba(255, 118, 20, 0.13), 0px 6.65px 5.32px 0px rgba(255, 118, 20, 0.11), 0px 2.767px 2.214px 0px rgba(255, 118, 20, 0.07)'
              }}
            >
              <Link
                to={settings.link_register}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center px-[8px] py-[10px] rounded-full w-full h-full font-bold text-[16px] leading-[24px] text-center whitespace-nowrap text-white relative overflow-hidden"
                style={{
                  background: 'linear-gradient(to bottom, rgba(255, 214, 179, 0), #df630b)',
                  // border: '1px solid rgba(255, 248, 243, 0)',
                  boxShadow: 'inset 0px 4px 4px 0px rgba(255, 191, 0, 0.16)'
                }}
              >
                ĐĂNG KÝ
              </Link>
            </div>
          </div>
          <div
            className="md:hidden flex bg-[#feb562] mt-1 flex-col items-start p-px rounded-full w-full h-[36px]"
            style={{
              boxShadow:
                '0px 12.522px 10.017px 0px rgba(255, 118, 20, 0.13), 0px 6.65px 5.32px 0px rgba(255, 118, 20, 0.11), 0px 2.767px 2.214px 0px rgba(255, 118, 20, 0.07)'
            }}
          >
            <Link
              to={navItems[0].href || '/'}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center px-[12px] py-[4px] rounded-full w-full h-full font-bold text-[14px] leading-[24px] text-center whitespace-nowrap text-white cursor-pointer relative overflow-hidden"
              style={{
                background: 'linear-gradient(to bottom, rgba(255, 214, 179, 0), #df630b)',
                // border: '1px solid rgba(255, 248, 243, 0)',
                boxShadow: 'inset 0px 4px 4px 0px rgba(255, 191, 0, 0.16)'
              }}
            >
              Trang Chủ
            </Link>
          </div>
        </div>
      </div>
      <div className="w-full h-auto flex justify-center items-center relative">
        <img
          src="/assets/images/header/banner_pc.png"
          alt=""
          className="w-[90%] md:w-full max-w-[666px] h-auto object-contain mt-2 py-2 flex"
        />
        {/* <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 mt-[10px] md:mt-[24px]">
          <CountDownFinal />
        </div> */}
      </div>

      {/* <div className="flex justify-center items-center w-full px-2 mb-3">
        <div className="md:hidden flex flex-row justify-center items-center w-full gap-2 sm:gap-3 lg:gap-10 py-3 rounded-full bg-white">
          {navItems.map((item) =>
            item.name === 'Trang chủ' ? null : (
              <Link
                key={item.name}
                to={item.href}
                className={`text-center text-[14px] px-5 py-2 rounded-lg sm:text-[16px] font-semibold ${
                  activeNav === item.href
                    ? 'text-[#FFF] bg-[#f27121]'
                    : 'text-[#f27121] bg-transparent'
                }`}
              >
                {item.name}
              </Link>
            )
          )}
          <button
            onClick={() => setIsModalHistory(true)}
            className={`text-center text-[14px] sm:text-[16px] font-semibold text-[#f27121] cursor-pointer bg-transparent border-0`}
          >
            LỊCH SỬ
          </button>
        </div>
      </div> */}

      <HistoryPredictions
        isModalVote={isModalHistory}
        setIsModalVote={setIsModalHistory}
        IP={IP}
        FP={FP}
      />
    </div>
  );
};

export default Header;
